import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  axiosGet,
  axiosPost,
  reactQueryDefaultOptions,
} from "../helpers/baseApi";
import { SERVICE_URLS } from "../helpers/serviceUrls";
import { QUERY_KEYS } from "../helpers/queryKeys";

// SOF-816: read the configured maximum contribution limits for an OE period.
// Used by the client-facing HSA/FSA/DCA config pages to render info labels and
// by the admin configuration page to prefill the form.
export const useQueryGetFlexContributionLimits = (oePeriodId) => {
  const getData = async () => {
    return await axiosGet(SERVICE_URLS.FLEX_CONTRIBUTION_LIMITS_GET(oePeriodId));
  };

  return useQuery(
    [QUERY_KEYS.FLEX_CONTRIBUTION_LIMITS, oePeriodId],
    getData,
    {
      ...reactQueryDefaultOptions,
      enabled: !!oePeriodId,
    }
  );
};

// SOF-816: admin-only save of the flexible benefit contribution limits.
export const useMutatePostFlexContributionLimits = () => {
  const postData = async (data) => {
    return await axiosPost(SERVICE_URLS.FLEX_CONTRIBUTION_LIMITS_POST, data);
  };

  const queryClient = useQueryClient();

  return useMutation(postData, {
    onSuccess: (result, variables) => {
      queryClient.invalidateQueries([
        QUERY_KEYS.FLEX_CONTRIBUTION_LIMITS,
        variables?.oePeriodId,
      ]);
    },
  });
};
